import { string } from '@amcharts/amcharts4/core';
import { CommonService } from './../../../shared/services/common.service';
import { Component, OnInit, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, NgForm } from '@angular/forms';
import { ResellerInfoModel } from '../../../account/models/profile/reellerInfoModel';
import { OrderInfoModel } from '../../models/orderInfoModel';
import { BankTranactionModel } from '../../models/bankTranactionModel';
import { OrderInfoItems } from '../../models/orderInfoItems';
import { Subscription } from 'rxjs';
import { PurchaseService } from '../../services/purchase.service';
import { MatDialog, MatStepper, MatSnackBar } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { AccountService } from '../../../account/services/account.service';
import { PurchaseProductModel } from '../../models/purchaseProductModel';
import { PurchaseOrderModel } from '../../models/purchaseOrderModel';
import { ClipboardService } from 'ngx-clipboard';
import { ContactInfoModel } from '../../../shared/models/contactInfoModel';
import { SharedObject } from '../../../shared/sharedObject';

@Component({
  selector: 'app-purchase',
  templateUrl: './purchase.component.html',
  styleUrls: ['./purchase.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PurchaseComponent implements OnInit {
  @ViewChild('stepper') stepper: MatStepper;

  //موقع ساخت سفارش
  loading = false;
  //موقع ارسال به صفحه بانک
  bankPaymentLoading = false;
  //دکمه خرید
  disabled = false;
  showMessage = null;
  //غیر فعال شدن دکمه ارسال به بانک
  disabledPaymentSubmited = true;
  //اطلاعات کاربر
  sellerInfo: ResellerInfoModel = new ResellerInfoModel();
  purchaseFormGroup: FormGroup;
  //ذخیره اطلاعات کاربر لاگین شده شامل شماره تماس
  contactInfoModel: ContactInfoModel = new ContactInfoModel();
  //شماره سفارش
  orderId: string = null;
  //نمایش خطای هنگام ثبت سفارش در مرحله یک
  orderErrorMessage: string = null;
  //مربوط به ارسال به سمت بانک
  bankorderId: string;
  bankTransactionId: string;
  activationCode: string;
  year: string;
  deviceCount: string;
  bankTranactionModel: BankTranactionModel = new BankTranactionModel();
  //در صفحه آغازین برای نمایش یا عدم نمایش مرحله انتخاب نوع محصول
  selectVersion = false;

  orderLoading: boolean = false; //لود سفارش
  currentOrder: OrderInfoModel = new OrderInfoModel();
  currentOrderItem: OrderInfoItems = new OrderInfoItems();
  productList: PurchaseProductModel[] = [];
  productListLoading = true;
  selectedProduct: PurchaseProductModel = new PurchaseProductModel();

  discountCode: string;
  discountValue: number = 0;
  discountPercent: number = 0;
  discountWait: boolean = false;
  discountError: boolean = false;
  private routerParmsSub: Subscription;
  getWay: number = null;
  getWayName: string;
  paymentErrorMessage: string = null;
  productId: number = 1;
  complateActionLabel: string = "دریافت کد فعالسازی";
  hasDiscount:boolean=false;
  constructor(
    private _formBuilder: FormBuilder,
    private purchaseService: PurchaseService,
    private changeDetectorRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    public snackBar: MatSnackBar,
    private clipboardService: ClipboardService,
    private commonService: CommonService

  ) { }

  ngOnInit() {
    this.initializePurchasePostForm();
    // params['bankorderId'] && params['bankTransactionId'] && params['activationCode']
    this.routerParmsSub = this.route.params.subscribe(params => {
      if (this.route.snapshot.queryParamMap.get('bankorderId') &&
        this.route.snapshot.queryParamMap.get('bankTransactionId') &&
        this.route.snapshot.queryParamMap.get('activationCode') &&
        this.route.snapshot.queryParamMap.get('year') &&
        this.route.snapshot.queryParamMap.get('deviceCount')
      ) {
        this.bankorderId = this.route.snapshot.queryParamMap.get('bankorderId');
        this.bankTransactionId = this.route.snapshot.queryParamMap.get('bankTransactionId');
        this.activationCode = this.route.snapshot.queryParamMap.get('activationCode');
        this.year = this.route.snapshot.queryParamMap.get('year');
        this.deviceCount = this.route.snapshot.queryParamMap.get('deviceCount');
        this.stepper.selectedIndex = 3; //رفتن به آخرین صفحه و نمایش پیغام موفقیت آمیز بودن
      } else if (this.route.snapshot.queryParamMap.get('discountCode') || params['discountCode']) {
        const controls = this.purchaseFormGroup.controls;
        controls['discountCodeControl'].setValue(params['discountCode'] ? params['discountCode'] : this.route.snapshot.queryParamMap.get('discountCode'));
        this.selectVersion = false;
        this.discountCode = params['discountCode'] ? params['discountCode'] : this.route.snapshot.queryParamMap.get('discountCode');
        this.enterDiscountCode();

      } else if (this.route.snapshot.queryParamMap.get('msg')) {
        this.paymentErrorMessage = this.route.snapshot.queryParamMap.get('msg');
        this.stepper.selectedIndex = 3; //رفتن به آخرین صفحه و نمایش پیغام خطا
        this.complateActionLabel = "خرید ناتمام"
      }
      this.loadProducts();

      this.loadContractInfo();
    }, err => { });
  }

  loadProducts() {
    this.purchaseService.getPurchaseProducts(this.productId).subscribe((res: PurchaseProductModel[]) => {
      this.productListLoading = false;
      this.productList = res.sort((n1,n2) => n1.id - n2.id);
      this.selectedProduct = this.productList[0];
      this.hasDiscount=this.selectedProduct.price<this.selectedProduct.displayPrice;
      this.changeDetectorRef.markForCheck();
      this.enterDiscountCode();

    });
  }

  loadContractInfo() {
    this.commonService.getContactInfo().subscribe((res: ContactInfoModel) => {
      this.contactInfoModel = res;
      this.changeDetectorRef.markForCheck();
    });
  }


  initializePurchasePostForm() {
    this.purchaseFormGroup = this._formBuilder.group({
      selectedProductType: ['', Validators.compose([
        Validators.required
      ])
      ],
      mobileNumber: ['', Validators.compose([
        Validators.required,
        Validators.minLength(11),
        Validators.maxLength(11),
        Validators.pattern(SharedObject.MobilePattern)
      ]),
      ],
      discountCodeControl: ['', Validators.compose([])]
    });
  }

  enterDiscountCode() {
    if (this.discountCode==null || this.discountCode.length == 0) {
      this.discountError = false; //نمایش خطای نامعتبر بودن
      this.discountValue = 0;
      this.discountPercent = 0;
      this.changeDetectorRef.markForCheck();
      return;
    }
    if (this.discountCode.length > 0 && this.discountCode.length < 6) {
      this.discountError = false; //نمایش خطای نامعتبر بودن
      this.discountValue = 0;
      this.discountPercent = 0;
      this.changeDetectorRef.markForCheck();
      return;
    }
    this.discountWait = true;//نمایش اسپینر
    this.purchaseService.getDiscount(this.discountCode, this.productId).subscribe((res: number) => {
      if (res == 0) {
        this.discountError = true;
        this.discountPercent = 0;
        this.discountValue = 0;
        return;
      }
      this.discountError = false;//نمایش خطای نامعتبر بودن
      this.discountPercent = res;
      this.discountValue = this.selectedProduct.price * res / 100; //تخفیف
      this.discountWait = false; //نمایش اسپینر
      this.changeDetectorRef.markForCheck();
    }, (err) => {
      this.discountWait = false;//نمایش اسپینر
      this.discountPercent = 0;
      this.discountValue = 0;
    }, () => {
      this.discountWait = false;//نمایش اسپینر
      this.changeDetectorRef.markForCheck();
    });

  }

  async selectProductSubmit() {
    const controls = this.purchaseFormGroup.controls;
    // check form
    if (this.purchaseFormGroup.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }
    this.showMessage = null;
    var model = new PurchaseOrderModel();
    model.customerContact = controls['mobileNumber'].value;
    model.priceId = this.selectedProduct.id;
    model.productId = 1;
    model.orderCount = 1;
    model.DiscountCode = this.discountCode;
    model.IsRenewal = false;
    this.loading = true;
    this.disabled = true;
    await this.purchaseService.createPurchaseOrder(model).toPromise().then((res: number) => {
      if (res <= 0) {
        this.loading = false;
        this.disabled = false;
        return;
      }
      this.orderId = res['orderId'];
      this.stepper.next();
      window.scroll(0, 0); //scroll to top
      this.loading = false;
      this.disabled = false;
      this.changeDetectorRef.markForCheck();
    }, (err) => {
      this.loading = false;
      this.disabled = false;
      this.orderErrorMessage = err.error['result'];
      this.changeDetectorRef.markForCheck();
      return;
    });
    this.orderLoading = true;
    await this.purchaseService.getPurchaseOrder(this.orderId).toPromise().then((res: OrderInfoModel) => {
      this.changeDetectorRef.markForCheck();
      this.currentOrder = res;
      this.orderLoading = false;
      this.currentOrderItem = this.currentOrder.orderItems[0];
      this.getWay = this.currentOrderItem.defaultGateway;
      this.getWayName = this.getBankName(this.getWay);
      this.disabledPaymentSubmited = false;//فعال کردن دکمه ارسال به صفحه بانک
      this.changeDetectorRef.markForCheck();
    });

  }

  changeGetWay(value: number) {
    this.getWay = value;
    this.getWayName = this.getBankName(this.getWay);
    this.changeDetectorRef.markForCheck();
  }

  bankPaymentClick() {
    if (!this.getWay || this.getWay == null) {
      this.showMessage = "لطفا درگاه پرداخت را انتخاب نمائید";
      return;
    }
    this.showMessage = null;
    this.disabledPaymentSubmited = true; //غیر فعال می کند تا کاربر دو بار کلیک نکند
    this.bankPaymentLoading = true;

    this.purchaseService.doBankPayment(this.currentOrder.orderId, this.getBankNameId(this.getWay))
      .subscribe((res: BankTranactionModel) => {
        this.bankTranactionModel = res;
        this.changeDetectorRef.markForCheck();
        this.postRefId(res.refId, res.sendToBankUrl, res.sendMethod)
        this.bankPaymentLoading = false;
      }, err => {
        window.scrollTo(0, 0);
        this.showMessage = err.error['result'];
        this.bankPaymentLoading = false;
        this.disabledPaymentSubmited = false;
        this.changeDetectorRef.markForCheck();

      }, () => {
        this.bankPaymentLoading = false;
        this.changeDetectorRef.markForCheck();

      });
  }
  copyCode(code: string) {
    if (code == null) return;

    this.clipboardService.copyFromContent(code);
    this.snackBar.open("با موفقیت کپی شد", null, {
      duration: 2000,
    });
  }
  postRefId(refIdValue: string, bankUrl: string, sendMethod: string) {
    try {
      if (sendMethod.toLowerCase() === 'get') {
        window.location.href = bankUrl;
        return false;
      } else {

        var form = document.createElement("form");
            form.setAttribute("method",sendMethod);
            form.setAttribute("action", bankUrl);
            form.setAttribute("target", "_self");
            var hiddenField = document.createElement("input");
            hiddenField.setAttribute("name", "RefId");
            hiddenField.setAttribute("value", refIdValue);
            form.appendChild(hiddenField);
            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
      }

    } catch{
      this.bankPaymentLoading = false;
      this.disabledPaymentSubmited = false;
      this.showMessage = "خطا در ارسال به بانک پذیرنده";
      this.changeDetectorRef.markForCheck();
    }

  }
  getBankName(id: number): string {
    if (id == 1) return "پارسیان";
    if (id == 2) return "ملت";

    if (id == 3) return "زرین پال";
    if (id == 4) return "زرین پال";
  }

  getBankNameId(id: number): string {
    if (id == 1) return "parsian";
    if (id == 2) return "melat";

    if (id == 3) return "zarinpal1";
    if (id == 4) return "zarinpal2";
  }



  backStepper3() {
    this.orderId = null;
    this.bankPaymentLoading = false;
    this.stepper.previous();
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.purchaseFormGroup.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  changeProduct() {
    
    this.discountValue = this.selectedProduct.price * this.discountPercent / 100; //تخفیف
    this.hasDiscount=this.selectedProduct.price<this.selectedProduct.displayPrice;
  }


  
}
